module.exports = __webpack_public_path__ + "img/default_bg.193e3ea8.jpg";